<template>
    <div class="w-full h-full px-2 md:px-4 lg:px-8 py-4">
        <h1 class="text-gray-700 dark:text-gray-100 text-center lg:text-left text-2xl tracking-widest uppercase">Criar novo produto</h1>
        <form class="flex flex-row flex-wrap mx-auto w-full md:w-10/12 lg:w-1/2 my-8 gap-y-5 gap-x-2" @submit.prevent="createProduct('complemento')">
            <p class="w-full font-bold text-gray-600 dark:text-gray-200">Produto</p>
            <span class="w-full md:flex-1">
                <Autocomplete :validation="v$.seg" v-model="segmento" label="Segmento" placeholder="Selecionar complemento" :list="segmentos" desc="descricao" @filter="filterMarcas()"/>
                <p @click="createProduct('segmento');getLists()" v-if="!segmentos.map(a => a.descricao.toLowerCase()).includes(segmento.toLowerCase()) && segmento !== ''" class="text-indigo-500 text-sm cursor-pointer hover:underline">Esse segmento não existe. Clique para criar</p>
            </span>

            <span class="w-full md:flex-1">
                <Autocomplete :disabled="!segmento" v-model="marca" label="Marca" placeholder="Selecionar marca" :list="marcas" desc="marca" @filter="filterModelos()"/>
                <p @click="createProduct('marca');getLists()" v-if="!marcas.map(a => a.marca.toLowerCase()).includes(marca.toLowerCase()) && marca !== ''" class="text-indigo-500 text-sm cursor-pointer hover:underline">Esse marca não existe. Clique para criar</p>
            </span>

            <span class="w-full md:flex-1">
                <Autocomplete :disabled="!segmento && !marca" v-model="modelo" label="Modelo" placeholder="Selecionar modelo" :list="modelos" desc="descricao" />
                <p @click="createProduct('modelo');getLists()" v-if="!modelos.map(a => a.descricao.toLowerCase()).includes(modelo.toLowerCase()) && modelo !== ''" class="text-indigo-500 text-sm cursor-pointer hover:underline">Esse modelo não existe. Clique para criar</p>
            </span>
            <div class="w-full flex space-x-2">

                <span class="w-full">
                    <Input :disabled="!modelo" v-model="complemento" label="Complemento" />
                </span>
                <span class="w-full">
                    <Input type="text" :disabled="!complemento" v-model="id" label="Identificador" v-maska="'############'"/>
                </span>
            </div>

            <button type="submit" class="btn w-full h-12 bg-indigo-600 text-gray-50 rounded-lg text-sm" :disabled="segmento === '' || marca === '' || modelo === '' || complemento === '' || complemento === ''">CRIAR</button>
        </form>
    </div>
</template>

<script>
import Input from '@/components/Design/Input'
import Autocomplete from '@/components/Design/Autocomplete'
import Select from '@/components/Design/Select'
import { GET_SEGMENTOS, GET_MODELOS_BY_MARCA, GET_MARCAS_BY_SEGMENTO, POST_SEGMENTOS, POST_MARCAS, POST_MODELOS, POST_COMPLEMENTO } from '../../mixins/api.js'
import { computed, onMounted, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { findId } from '../../mixins/findData.js'
import { displayNotification } from '../../mixins/notification.js'
export default {
    name: 'NovaLoja',
    components: {
        Input,
        Select,
        Autocomplete
    },
    setup () {
        const segmentos = ref([])
        const segmento = ref('')
        const marcas = ref([])
        const marca = ref('')
        const modelos = ref([])
        const modelo = ref('')
        const complemento = ref('')
        const id = ref('')

        const filterModelos = async () => {
            if (marca.value === '') {
                modelo.value = ''
                modelos.value = []
                complemento.value = ''
            } else {
                const id = findId(marcas.value, marca.value, 'marca')
                await GET_MODELOS_BY_MARCA(id).then(r => {
                    modelos.value = r.data
                })
            }
        }

        const filterMarcas = async () => {
            if (segmento.value === '') {
                marca.value = ''
                marcas.value = []
                modelo.value = ''
                modelos.value = []
                complemento.value = ''
            } else {
                const id = findId(segmentos.value, segmento.value, 'descricao')
                await GET_MARCAS_BY_SEGMENTO(id).then(r => {
                    marcas.value = r.data
                })
            }
        }

        const getLists = async () => {
            await GET_SEGMENTOS().then(r => {
                segmentos.value = r.data
            })
            filterMarcas()
            filterModelos()
        }

        onMounted(async () => {
            await getLists()
        })

        const rules = computed(() => {
            return {
                segmento:
                    { uincludes: (value) => segmentos.value.map(a => a.descricao).includes(value.value) }

            }
        })
        const v$ = useVuelidate(rules, { segmento })

        const createProduct = async (type) => {
            let request = null
            let body = {}
            if (type === 'segmento') {
                request = POST_SEGMENTOS
                body = {
                    descricao: segmento.value,
                    porcentagem: 20
                }
            } else if (type === 'marca') {
                request = POST_MARCAS
                body = {
                    segmento_id: findId(segmentos.value, segmento.value, 'descricao'),
                    marca: marca.value
                }
            } else if (type === 'modelo') {
                request = POST_MODELOS
                body = {
                    segmento_id: findId(segmentos.value, segmento.value, 'descricao'),
                    marca_id: findId(marcas.value, marca.value, 'marca'),
                    descricao: modelo.value
                }
            } else {
                request = POST_COMPLEMENTO
                body = {
                    segmento_id: findId(segmentos.value, segmento.value, 'descricao'),
                    marca_id: findId(marcas.value, marca.value, 'marca'),
                    modelo_id: findId(modelos.value, modelo.value, 'descricao'),
                    descricao: complemento.value,
                    id_item: parseInt(id.value)
                }
            }
            await request(body).then(async (r) => {
                displayNotification(r)
                if (type === 'complemento') {
                    segmento.value = ''
                    marca.value = ''
                    modelo.value = ''
                    complemento.value = ''
                    id.value = ''
                    v$.value.$reset()
                }
            }).catch(e => {
                displayNotification(e.response)
            })
            getLists()
        }
        return {
            segmentos,
            segmento,
            marcas,
            marca,
            modelos,
            modelo,
            complemento,
            id,
            filterModelos,
            filterMarcas,
            v$,
            createProduct,
            getLists
        }
    }
}
</script>
<style>
</style>
